import clsx from "clsx";
import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import { useFormContext } from "react-hook-form";

import { GenericApiValue } from "../../../../api-http/types";
import { FormFieldStatus, Select } from "../../elements";
import { BusinessRelationshipFormFieldsLabels, BusinessRelationshipFormFieldsTypes } from "./types";

export interface BusinessRelationshipFormFieldsProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  labels: BusinessRelationshipFormFieldsLabels;
  defaultValue?: string;
  optionsList?: GenericApiValue[] | null;
}

export function BusinessRelationshipFormFields({
  labels,
  className,
  defaultValue,
  optionsList,
}: BusinessRelationshipFormFieldsProps) {
  const formMethods = useFormContext<BusinessRelationshipFormFieldsTypes>();
  const { errors } = formMethods.formState;

  return (
    <Select
      className={clsx("w-full", className)}
      label={labels.businessRelationship}
      message={errors.businessRelationship?.message ?? undefined}
      status={
        errors.businessRelationship?.message ? FormFieldStatus.Error : FormFieldStatus.Warning
      }
      required
      optionalLabel={labels.optionalLabel}
      defaultValue={defaultValue}
      {...formMethods?.register("businessRelationship", { required: labels.requiredFieldMessage })}
    >
      {optionsList?.map(({ value, id }) => (
        <option key={id} value={id}>
          {value}
        </option>
      ))}
    </Select>
  );
}
